
// Initialiser toutes les cartes sur la page
const initMaps = () => {
  // Vérifier que mapboxgl est disponible
  if (typeof window.mapboxgl === 'undefined') {
    return;
  }

  window.mapboxgl.accessToken = 'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2t4NGo0OXB6MTY4dDJ1dXFxbzczZmp6NiJ9.KpzE7WQEVkf28s5JmI2KiQ';
  const defaultCoordinates = [5.868781853066553, 49.25332076164668];
  const cities = [
    {
      name: 'Strasbourg',
      coordinates: [
        7.7462466954085585, 48.584171878118326
      ]
    },
    {
      name: 'Colmar',
      coordinates: [7.357927666560528, 48.077168201294455]
    },
    {
      name: 'Haguenau',
      coordinates: [7.78911288807808,48.815361119370294]
    },
    {
      name: 'Metz',
      coordinates: [6.175047923053484, 49.11893360270247]
    },
    {
      name: 'Nancy',
      coordinates: [6.181753094800683, 48.6945344667651060]
    },
    {
      name: 'Reims',
      coordinates: [4.029950693271445,49.25665918446035]
    },
    {
      name: 'Charleville Mezières',
      coordinates: [4.720645636228511,49.77483567421979]
    },
    {
      name: 'Maubeuge',
      coordinates: [3.9742546899072124,50.27962768405888]
    },
    {
      name: 'Rennes',
      coordinates: [-1.6816218689815514,48.11357856001237]
    },
    {
      name: 'Verdun',
      coordinates: [5.386191605272188,49.161145688500966]
    },
    {
      name: 'Chalon sur Saone',
      coordinates: [4.854004825997492,46.781524410768924]
    },
    {
      name: 'Dijon',
      coordinates: [ 5.039846999653292,47.323369160218476]
    },
    {
      name: 'Lille',
      coordinates: [3.0631791562893227,50.63692264968117]
    },
    {
      name: 'Dunkerque',
      coordinates: [3.0631791562893227,50.63692264968117]
    },
    {
      name: 'Rouen',
      coordinates: [1.0990142374807874,49.44407714681475]
    },
    {
      name: 'Avignon',
      coordinates: [4.8073521611174215,43.94941162529088]
    },
    {
      name: 'Paris et région parisienne',
      coordinates: [2.349017588684376,48.854434522144174]
    },
    {
      name: 'Narbonne',
      coordinates: [3.003283641032084,43.184830946130944]
    },
    {
      name: 'Angoulême',
      coordinates: [0.15589540064931384,45.64914640363]
    },
    {
      name: 'Liège (Belgique)',
      coordinates: [5.573231520166928,50.646881915153784]
    },

  ];
  // Chercher l'ancien élément #map
  const oldMapElement = document.querySelector('#map');
  
  // Chercher tous les éléments avec la classe map-column
  const mapColumnElements = document.querySelectorAll('.map-column');
  
  // Créer un tableau avec tous les éléments à initialiser
  const allMapElements = [];
  
  // Ajouter l'ancien élément #map s'il existe et n'a pas déjà été initialisé
  if (oldMapElement && oldMapElement.dataset.mapInitialized !== 'true') {
    allMapElements.push(oldMapElement);
  }
  
  // Ajouter tous les éléments .map-column qui n'ont pas encore été initialisés
  mapColumnElements.forEach((element) => {
    if (element.dataset.mapInitialized !== 'true') {
      allMapElements.push(element);
    }
  });

  // Initialiser chaque carte
  allMapElements.forEach((mapElement) => {
    try {
      const map = new window.mapboxgl.Map({
        container: mapElement, // Passer l'élément directement
        style: 'mapbox://styles/mapbox/light-v10', // style URL
        center: cities.length ? cities[0].coordinates : defaultCoordinates, // starting position [lng, lat]
        zoom: 12 // starting zoom
      });

      const bounds = new window.mapboxgl.LngLatBounds();

      cities.forEach((city) => {
        new window.mapboxgl.Marker({
          color: '#288ECA',
          draggable: false,
          scale: '1.1'
        })
          .setLngLat(city.coordinates)
          .addTo(map);

        bounds.extend(city.coordinates);
      });

      if (cities.length > 1) {
        map.fitBounds(bounds, {
          padding: 40,
          maxZoom: 12
        });
      } else if (cities.length === 1) {
        map.setCenter(cities[0].coordinates);
      }

      // Marquer comme initialisé pour éviter les doublons
      mapElement.dataset.mapInitialized = 'true';
    } catch (error) {
      console.error('Erreur lors de l\'initialisation de la carte:', error);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMaps);
} else {
  initMaps();
}


// WEBPACK FOOTER //
// ./scripts/modules/map.js